import { Component, OnInit, Inject } from '@angular/core';
import { OrganisationService } from '../organisation.service';
import { UtilitiesService } from '../../../../common/shared/services/utilities.service';
import { Membership } from '../../../../common/models/membership';
import { HierarchicalOrganisation } from '../../../../common/models/hierarchical-rganisation';
import { NestedTreeControl } from '@angular/cdk/tree';
import { OrganisationCategoryEnum, StatusEnum } from '../../../../common/helper/enums';
import { Organisation } from '../../../../common/models/organisation';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-organisation-form',
  templateUrl: './organisation-form.component.html',
  styleUrls: ['./organisation-form.component.scss']
})
export class OrganisationFormComponent implements OnInit {

  choosenOrganisations: string[];
  organisationsFlat: Organisation[];
  treeControl = new NestedTreeControl<HierarchicalOrganisation>(node => node.children);
  dataSource = new MatTreeNestedDataSource<HierarchicalOrganisation>();
  StatusEnum: typeof StatusEnum = StatusEnum;
  OrganisationCategoryEnum: typeof OrganisationCategoryEnum = OrganisationCategoryEnum;

  constructor(
    @Inject(MAT_DIALOG_DATA) private memberships: Membership[],
    public dialogRef: MatDialogRef<OrganisationFormComponent>,
    private _organisationService: OrganisationService,
    private _utilitiesService: UtilitiesService) { }

  ngOnInit() {
    this.choosenOrganisations = [];
    this.organisationsFlat = [];

    if (this._utilitiesService.wasOrgPreChoosen()) {
      this.choosenOrganisations = [this._utilitiesService.getPreChoosenOrganisation()];
      this.create();
      this._utilitiesService.deletePreChoosenOrganisation();
    } else {
      this._utilitiesService.addMinorAction('LoadOrganisations');
      this._organisationService.loadOrganisations().subscribe(
        data => {
          this.dataSource.data = this._utilitiesService.getData(data);
          this._utilitiesService.removeAction('LoadOrganisations');
        },
        err => {
          this._utilitiesService.handleErrors(err);
          this.dialogRef.close('Close');
        }
      );
      this._organisationService.loadOrganisationsFlat().subscribe(
        data => {
          this.organisationsFlat = this._utilitiesService.getData(data);
        },
        err => {
        }
      );
    }
  }

  create() {
    this._utilitiesService.addMinorAction('CreateMemberships');
    this._organisationService.createMemberships(this.choosenOrganisations).subscribe(
      data => {
        this._utilitiesService.removeAction('CreateMemberships');
        if (this._utilitiesService.getData(data)) {
          this.dialogRef.close('Success');
        } else {
          this.dialogRef.close('Error');
        }
      },
      err => {
        this._utilitiesService.handleErrors(err);
        this.dialogRef.close('Close');
      }
    );
  }

  close() {
    this.dialogRef.close('Canceled');
  }

  createActionActive() {
    return this._utilitiesService.isActionActive('CreateMemberships');
  }

  loadActionActive() {
    return this._utilitiesService.isActionActive('LoadOrganisations');
  }

  hasChild = (_: number, node: HierarchicalOrganisation) => !!node.children && node.children.length > 0;

  organisationChoosable(category: OrganisationCategoryEnum) {
    if (category === OrganisationCategoryEnum.Selectable || category === OrganisationCategoryEnum.RequiresApplication) {
      return true;
    }
    return false;
  }

  organisationNotOnList(organisationId: string) {
    return !this.organisationOnList(organisationId);
  }

  organisationOnList(organisationId: string) {
    if (!this.choosenOrganisations) {
      return false;
    }
    return this.choosenOrganisations.indexOf(organisationId) !== -1;
  }

  addOrganisationToList(organisationId: string) {
    if (this.organisationNotOnList(organisationId)) {
      this.choosenOrganisations.push(organisationId);
    }
  }

  removeOrganisationFromList(organisationId: string) {
    if (this.organisationOnList(organisationId)) {
      const index = this.choosenOrganisations.indexOf(organisationId);
      this.choosenOrganisations.splice(index, 1);
    }
  }

  hasAlreadyActiveMembership(organisationId: string) {
    const tmpMedlemskap = this.memberships.find( x => x.organisationId === organisationId && x.status === this.StatusEnum.Active);
    if (tmpMedlemskap != null) {
      return true;
    }

    return false;
  }

  getOrganisationNameByID(organisationId: string) {
    const organisation = this.organisationsFlat.find(x => x.id === organisationId);
    if (organisation && organisation !== null) {
      return organisation.name;
    }
    return '';
  }
}
